import React, { Suspense } from 'react';
import { FilterByTagsSkeleton } from './FilterByTags.skeleton';
import { MEDIA_BREAKPOINTS } from '../../../constants/MEDIA_BREAKPOINTS';
import { useParams } from 'react-router-dom';
import { useHierarchyContext } from '../../hooks/useHierarchyContext';
const FilterByTagsComponent = React.lazy(async () => await import('./FilterByTags.component'));
const FilterByTags = () => {
    const { handle } = useParams();
    const { objects } = useHierarchyContext();
    const collObject = objects[handle ?? ''];
    if (!MEDIA_BREAKPOINTS.MD_UP.matches ||
        window.Cookies.get('ab_filterByTags') === undefined ||
        (collObject?.parent !== null && collObject?.children.length > 0)) {
        return null;
    }
    return (React.createElement(Suspense, { fallback: React.createElement(FilterByTagsSkeleton, null) },
        React.createElement(FilterByTagsComponent, null)));
};
export default FilterByTags;
